import React, { useState, useEffect } from 'react'
import './index.css'
import RadioItem from '../RadioItem'
// interface RadioItemProps {
//     selected?: boolean
//     label?: string
//     onSelect?: () => void
// }
// const RadioItem: React.FC<RadioItemProps> = (props) => {
//     return <div className="radio-item" onClick={props.onSelect}>
//         {props.selected && <img className="radio-icon" src={RadioActiveIcon} alt="icon" />}
//         {!props.selected && <img className="radio-icon" src={RadioInactiveIcon} alt="icon" />}
//         {props.label && <span className="radio-label">{props.label}</span>}
//         {props.children}
//     </div>
// }
export type ContactSelectType = 'all' | 'appoint' | null
interface ContactRadioGroupProps {
    onSelect?: (type: ContactSelectType) => void
    allLabel?: string
    appointLabel?: string
    title?: string
    selectType?: ContactSelectType
}
const ContactRadioGroup: React.FC<ContactRadioGroupProps> = (props) => {
    const {
        onSelect = () => undefined,
        allLabel = '全部群',
        appointLabel = '指定群',
        title = '群',
        selectType,
    } = props
    const [selectedKey, setSelectedKey] = useState<ContactSelectType | null>(
        null
    )
    useEffect(() => {
        if (selectType) {
            setSelectedKey(selectType)
        }
    }, [selectType])
    return (
        <div className='radio-group'>
            <p className='radio-group-title'>{title}</p>
            <RadioItem
                className='contact-radio-item'
                label={allLabel}
                selected={selectedKey === 'all'}
                onSelect={() => {
                    onSelect(selectedKey === 'all' ? null : 'all')
                    setSelectedKey(selectedKey === 'all' ? null : 'all')
                }}
            />
            <RadioItem
                className='contact-radio-item'
                label={appointLabel}
                selected={selectedKey === 'appoint'}
                onSelect={() => {
                    onSelect(selectedKey === 'appoint' ? null : 'appoint')
                    setSelectedKey(selectedKey === 'appoint' ? null : 'appoint')
                }}
            />
        </div>
    )
}

export default ContactRadioGroup
